export default "/images/square-plus.png?7bfb5b4ae2b1b31e4a6a4107da9da2a0";